import { Field, FieldsAPI } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PROGRAMS_QUERY_KEY } from '../types'
import { QUERY_KEY } from './queryKey'

export const useDeleteFieldsById = (queriesToInvalidate?: Array<Array<string>>) => {
  const queryClient = useQueryClient()
  return useMutation((fieldIds: string[]) => FieldsAPI.deleteFields(fieldIds), {
    mutationKey: [QUERY_KEY.FIELD_DELETE],
    onSuccess: (response, fieldIds) => {
      const invalidateQueries = queriesToInvalidate
        ? queriesToInvalidate
        : [[QUERY_KEY.FIELDS_PAGINATED]]
      invalidateQueries.forEach(query => queryClient.invalidateQueries(query))
      queryClient.invalidateQueries([QUERY_KEY.FIELDS_PAGINATED_FIELD_COUNT])
      queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAMS])
      queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.WORKFLOWS])

      queryClient.setQueryData(
        [QUERY_KEY.FIELDS, null],
        //@ts-ignore
        (currentFields: Field[]) =>
          currentFields?.filter(({ resourceId }) => !fieldIds.includes(resourceId)) || []
      )
    },
  })
}
